import { useEffect } from 'react';

const ClearRedirect = () => {
    useEffect(() => {
        // Clear all related localStorage keys
        localStorage.removeItem('selectedCategory');
        localStorage.removeItem('userType');
        localStorage.removeItem('2xgxgshdugyywerw12gh');

        // Optional: also clear sessionStorage and any cookies if needed
        // sessionStorage.clear();
        // document.cookie = "gta_mainstateuser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        // Delay a little to ensure clearing
        setTimeout(() => {
            window.location.href = 'https://100billion.in/';
        }, 300); // small delay ensures browser clears storage
    }, []);

    return (
        <div style={{ textAlign: 'center', padding: '3rem', height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <h2>Switching account...</h2>
            <p>Please wait while we reset your session.</p>
        </div>
    );
};

export default ClearRedirect;
